import { useIsAskHeidiSourcesShortcutsEnabled } from '@/features/flags';
import { IS_ASK_HEIDI_SHORTCUTS_ENABLED } from '@/features/flags/legacy-flags';
import dynamic from 'next/dynamic';
import { useCallback, useState, type ReactNode } from 'react';

const ComposerShortcutMenu = dynamic(
  () =>
    import('@/components/ui/floating-ask-heidi/composer-shortcut-menu').then(
      (mod) => mod.ComposerShortcutMenu
    ),
  { ssr: false, loading: () => null }
);

const ComposerShortcutMarketplace = dynamic(
  () =>
    import('@/components/ui/floating-ask-heidi/composer-shortcut-marketplace').then(
      (mod) => mod.ComposerShortcutMarketplace
    ),
  { ssr: false, loading: () => null }
);

/**
 * Shortcuts flyout for a composer's `+` menu. Flag-gated; the Composer bind
 * further hides the row when sending is blocked. See all opens the marketplace
 * beside the menu, not inside it.
 */
export const useComposerShortcutsFlyout = (): {
  renderShortcutsFlyout?: (actions: {
    onSend: (query: string) => void;
    close: () => void;
  }) => ReactNode;
  marketplace: ReactNode;
} => {
  const enabled =
    useIsAskHeidiSourcesShortcutsEnabled() || IS_ASK_HEIDI_SHORTCUTS_ENABLED();
  const [marketplaceOpen, setMarketplaceOpen] = useState(false);
  const renderShortcutsFlyout = useCallback(
    ({ onSend, close }: { onSend: (query: string) => void; close: () => void }) => (
      <ComposerShortcutMenu
        onSend={(query) => {
          onSend(query);
          close();
        }}
        onBrowse={() => {
          close();
          setMarketplaceOpen(true);
        }}
      />
    ),
    []
  );

  return {
    renderShortcutsFlyout: enabled ? renderShortcutsFlyout : undefined,
    marketplace: marketplaceOpen ? (
      <ComposerShortcutMarketplace onOpenChange={setMarketplaceOpen} />
    ) : null,
  };
};
